import { usePrintCheckpointQrCodes } from '../hooks/usePrintCheckpointQrCodes'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Modal } from '@hivewatch/dark'

import { CheckpointIProps } from '../../types/types'
import { BulkPrintBody } from '../components/BulkPrintBody'

interface DarkBulkPrintModalIProps {
  isOpen: boolean
  onClose: () => void
  checkpoints: CheckpointIProps[]
  facilityId: string
}

/**
 * Dark twin of BulkPrintModal — chrome only. The instructions, the paper
 * preview and the print-ready node come from BulkPrintBody, shared with the
 * legacy modal; the preview deliberately stays light because it simulates
 * printed paper.
 */
export const DarkBulkPrintModal = ({
  isOpen,
  onClose,
  checkpoints,
  facilityId,
}: DarkBulkPrintModalIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const { print, printRef, totalPages } = usePrintCheckpointQrCodes({
    checkpoints,
    facilityId,
    onClose,
  })

  return (
    <Modal
      // The body is long-form instructions plus a page preview, so it scrolls
      // rather than sizing the dialog to the content.
      bodyStyleOverrides={{ maxH: '70vh', overflowY: 'auto' }}
      colorScheme={colorScheme}
      isOpen={isOpen}
      maxW='700px'
      onClose={onClose}
      onSave={print}
      saveButtonLabel={t('floors:print_action')}
      showCancelButton
      size='compact'
      title={t('floors:print_modal_title')}
    >
      <BulkPrintBody
        checkpoints={checkpoints}
        printRef={printRef}
        totalPages={totalPages}
      />
    </Modal>
  )
}
